import { render } from "./IniciarJuego.vue?vue&type=template&id=94bc329a&scoped=true"
import script from "./IniciarJuego.vue?vue&type=script&lang=js"
export * from "./IniciarJuego.vue?vue&type=script&lang=js"

import "./IniciarJuego.vue?vue&type=style&index=0&id=94bc329a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94bc329a"]])

export default __exports__